/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/lecture-topics.
 *
 * `title` / `description` mirror the zh-Hant value (the locale the
 * snapshot is fetched with). For locale-aware UI, read the per-locale
 * `title_zhHant/zhHans/en` fields instead.
 */

export interface CmsTopicIndexEntry {
  id: number
  number: string
  audience: string
  title: string
  description: string
  audience_zhHant: string
  audience_zhHans: string
  audience_en: string
  title_zhHant: string
  title_zhHans: string
  title_en: string
  description_zhHant: string
  description_zhHans: string
  description_en: string
  image_media_id: number | null
  image_media_uuid: string | null
  image_alt: string
  image_alt_zhHant: string
  image_alt_zhHans: string
  image_alt_en: string
}

export const cmsLectureTopics: CmsTopicIndexEntry[] = [
  {
    "id": 1,
    "number": "01",
    "audience": "家長",
    "title": "AI 如何成為孩子的學習夥伴，而非認知的絆腳石",
    "description": "探討 AI 工具在兒童學習中的正面角色與潛在風險，幫助家長分辨「輔助」與「依賴」的界線。學習如何引導孩子善用 AI 啟發思考、延伸探索，同時守護專注力、創造力與深度理解的能力。",
    "image_media_id": 34,
    "image_media_uuid": "d84b0d26-562d-4def-bbb4-0372026956db",
    "image_alt": "AI 學習夥伴：AI 與孩子並肩同行，孩子自己想出答案，AI 以虛線的建議回應",
    "audience_zhHant": "家長",
    "audience_zhHans": "家长",
    "audience_en": "Parents",
    "title_zhHant": "AI 如何成為孩子的學習夥伴，而非認知的絆腳石",
    "title_zhHans": "AI 如何成为孩子的学习伙伴，而非认知的绊脚石",
    "title_en": "AI as a learning partner, not a cognitive stumbling block",
    "description_zhHant": "探討 AI 工具在兒童學習中的正面角色與潛在風險，幫助家長分辨「輔助」與「依賴」的界線。學習如何引導孩子善用 AI 啟發思考、延伸探索，同時守護專注力、創造力與深度理解的能力。",
    "description_zhHans": "探讨 AI 工具在儿童学习中的正面角色与潜在风险，帮助家长分辨「辅助」与「依赖」的界线。学习如何引导孩子善用 AI 启发思考、延伸探索，同时守护专注力、创造力与深度理解的能力。",
    "description_en": "Exploring the positive role and hidden risks of AI tools in children's learning, helping parents draw the line between scaffolding and over-dependence. Learn how to guide children to use AI to spark thinking and extend exploration, while protecting attention, creativity, and deep understanding.",
    "image_alt_zhHant": "AI 學習夥伴：AI 與孩子並肩同行，孩子自己想出答案，AI 以虛線的建議回應",
    "image_alt_zhHans": "AI 学习伙伴：AI 与孩子并肩同行，孩子自己想出答案，AI 以虚线的建议回应",
    "image_alt_en": "AI as a study partner: the AI walks alongside the child, who works out the answer while the AI replies with a dashed suggestion"
  },
  {
    "id": 2,
    "number": "02",
    "audience": "家長",
    "title": "陪伴孩子溫習的智慧：5 個有效複習策略指南",
    "description": "從認知科學與教育心理學出發，介紹適合不同年齡孩子的複習方法與節奏安排。幫助家長擺脫「陪讀等於催谷」的壓力，以更輕鬆有效的方式支持孩子鞏固所學、建立自信。",
    "image_media_id": 35,
    "image_media_uuid": "d42e5f9d-98d7-4f1e-9be0-36aace97f65a",
    "image_alt": "陪伴孩子溫習：家長與孩子坐在同一張桌旁，中間是列出五個策略的溫習清單，右邊是時鐘",
    "audience_zhHant": "家長",
    "audience_zhHans": "家长",
    "audience_en": "Parents",
    "title_zhHant": "陪伴孩子溫習的智慧：5 個有效複習策略指南",
    "title_zhHans": "陪伴孩子温习的智慧：5 个有效复习策略指南",
    "title_en": "The wisdom of revising with your child: a 5-strategy guide",
    "description_zhHant": "從認知科學與教育心理學出發，介紹適合不同年齡孩子的複習方法與節奏安排。幫助家長擺脫「陪讀等於催谷」的壓力，以更輕鬆有效的方式支持孩子鞏固所學、建立自信。",
    "description_zhHans": "从认知科学与教育心理学出发，介绍适合不同年龄孩子的复习方法与节奏安排。帮助家长摆脱「陪读等于催谷」的压力，以更轻松有效的方式支持孩子巩固所学、建立自信。",
    "description_en": "Drawing on cognitive science and educational psychology, this session introduces revision methods and rhythms suited to children of different ages. It helps parents step out of the sitting-with-equals-pressure-coaching trap, and support their children in consolidating learning and building confidence in a calmer, more effective way.",
    "image_alt_zhHant": "陪伴孩子溫習：家長與孩子坐在同一張桌旁，中間是列出五個策略的溫習清單，右邊是時鐘",
    "image_alt_zhHans": "陪伴孩子温习：家长与孩子坐在同一张桌旁，中间是列出五个策略的温习清单，右边是时钟",
    "image_alt_en": "Revising with a child: a parent and child at the same table, a sheet listing five strategies, and a clock"
  },
  {
    "id": 3,
    "number": "03",
    "audience": "家長",
    "title": "3 招建立正向親子關係，守護孩子身心健康",
    "description": "探討正向親子溝通的核心技巧，包括傾聽、同理與界線設定，讓關係成為孩子的情緒安全網。幫助家長在日常互動中培養孩子的心理韌性與幸福感，從小建立穩固的親子信任基礎。",
    "image_media_id": 36,
    "image_media_uuid": "5d90e25f-64de-4552-a8a0-c0253ad0bc0f",
    "image_alt": "正向親子關係：家長與孩子面對面，中間是連結兩人的橋與愛心，右邊是因關愛而長大的植物",
    "audience_zhHant": "家長",
    "audience_zhHans": "家长",
    "audience_en": "Parents",
    "title_zhHant": "3 招建立正向親子關係，守護孩子身心健康",
    "title_zhHans": "3 招建立正向亲子关系，守护孩子身心健康",
    "title_en": "3 ways to build a positive parent-child bond and protect wellbeing",
    "description_zhHant": "探討正向親子溝通的核心技巧，包括傾聽、同理與界線設定，讓關係成為孩子的情緒安全網。幫助家長在日常互動中培養孩子的心理韌性與幸福感，從小建立穩固的親子信任基礎。",
    "description_zhHans": "探讨正向亲子沟通的核心技巧，包括倾听、同理与界线设定，让关系成为孩子的情绪安全网。帮助家长在日常互动中培养孩子的心理韧性与幸福感，从小建立稳固的亲子信任基础。",
    "description_en": "Exploring the core skills of positive parent-child communication — listening, empathy, and boundary-setting — so that the relationship itself becomes their emotional safety net. Helps parents nurture psychological resilience and wellbeing in everyday interactions, building a stable foundation of trust from early childhood.",
    "image_alt_zhHant": "正向親子關係：家長與孩子面對面，中間是連結兩人的橋與愛心，右邊是因關愛而長大的植物",
    "image_alt_zhHans": "正向亲子关系：家长与孩子面对面，中间是连结两人的桥与爱心，右边是因关爱而长大的植物",
    "image_alt_en": "A positive parent-child relationship: parent and child face to face, a bridge with a heart between them, and a plant that grew from care"
  },
  {
    "id": 4,
    "number": "04",
    "audience": "家長",
    "title": "在AI時代陪伴孩子活出健康的數位生活，滿足孩子需求，建立連結。",
    "description": "從孩子的內在需求出發，理解他們為何沉迷屏幕，並學習以連結取代管控的陪伴方式。幫助家長在AI與數位工具無處不在的環境中，引導孩子建立健康、平衡且自主的數位生活習慣。",
    "image_media_id": 37,
    "image_media_uuid": "afde96a9-6c3a-4e07-a99e-fb0c92cb6a90",
    "image_alt": "健康數位生活：手機與吸引目光的磁力，中間是連結而非管控的選擇，右邊是日夜各在環內的平衡一天",
    "audience_zhHant": "家長",
    "audience_zhHans": "家长",
    "audience_en": "Parents",
    "title_zhHant": "在AI時代陪伴孩子活出健康的數位生活，滿足孩子需求，建立連結。",
    "title_zhHans": "在AI时代陪伴孩子活出健康的数位生活，满足孩子需求，建立连结。",
    "title_en": "Raising digitally healthy kids in the AI era: meet needs, build connection",
    "description_zhHant": "從孩子的內在需求出發，理解他們為何沉迷屏幕，並學習以連結取代管控的陪伴方式。幫助家長在AI與數位工具無處不在的環境中，引導孩子建立健康、平衡且自主的數位生活習慣。",
    "description_zhHans": "从孩子的内在需求出发，理解他们为何沉迷屏幕，并学习以连结取代管控的陪伴方式。帮助家长在AI与数位工具无处不在的环境中，引导孩子建立健康、平衡且自主的数位生活习惯。",
    "description_en": "Starting from children's inner needs, this session helps parents understand why kids get hooked on screens, and learn to replace control with connection. In an environment where AI and digital tools are everywhere, parents can guide children toward healthy, balanced, and autonomous digital habits.",
    "image_alt_zhHant": "健康數位生活：手機與吸引目光的磁力，中間是連結而非管控的選擇，右邊是日夜各在環內的平衡一天",
    "image_alt_zhHans": "健康数字生活：手机与吸引目光的磁力，中间是连结而非管控的选择，右边是日夜各在环内的平衡一天",
    "image_alt_en": "A healthy digital life: a phone and the pull of attention, a choice of connection over control, and a balanced day with day and night each in its place"
  }
]
